<template>
  <div class="department-price-setting">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1" stepTitle="套餐及价格" :isMType="isMType"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">新增套餐与价格</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm"
                        :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品规格" required>
              <template v-if="specList&&specList.length>0">
                <div class="model-content" v-for="(item,index) in specList" :key="index">
                  <div class="content">
                    <a-select v-model="item.name" allowClear :disabled="proSource!=0" placeholder="请选择"
                              @change="e=>onSelectedChange(e,item,index)"
                              style="max-width:400px;">
                      <a-select-option v-for="itemNorm in getCanSelectedOptions(item,index)"
                                       :key="itemNorm.code" :value="itemNorm.name">
                        {{ itemNorm.name }}
                      </a-select-option>
                    </a-select>
                    <a class="ml15" :disabled="specList.length === 1||proSource!=0" @click="deleteItem(item)">删除</a>
                  </div>
                  <div class="content-flex">
                    <div class="content-box" v-for="(SonItem,SonIndex) in item.valueList" :key="SonIndex">
                      <div class="content-row">
                        <a-checkbox :disabled="SonItem.name==''||proSource!=0" v-model="SonItem.isTrue"
                                    @change="onIsTrueChange(index,SonIndex)"></a-checkbox>
                        <div class="check-input">
                          <a-input :disabled="item.name==''||proSource!=0" v-model="SonItem.name"
                                   @change="onFocusEvent(index,SonIndex)" @blur="onBlurvent(index,SonIndex)"
                                   placeholder="请输入"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <a-button @click="addSpec" style="margin-right:15px;" :disabled="proSource!=0">
                <a-icon type="plus"/>
                添加新规格
              </a-button>
            </a-form-model-item>
            <a-form-model-item label="价格与库存" required>
              <a-table
                row-key="rowKey"
                ref="table"
                :loading="loading"
                :dataSource="dataList"
                :columns="tabColumns"
                :pagination="false"
              >
                <template v-for="(item,index) in editColumns" :slot="item.scopedSlots.customRender"
                          slot-scope="text,record,index">
                  <a-form-model-item
                    v-if="proSource===0||proSource==='0' || 'commissionPrice'===item.scopedSlots.customRender"
                    :validate-status="getValidateStatus(record,item.scopedSlots.customRender)"
                    :help="getErrorTips(record,item.scopedSlots.customRender)"
                  >
                    <a-input
                      :key="item.scopedSlots.customRender"
                      v-model="record[item.scopedSlots.customRender]"
                      placeholder="请输入"
                    />
                  </a-form-model-item>
                  <span v-else>{{ text }}</span>
                </template>
              </a-table>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" @click="onSubmit" :loading="submitLoading">提交</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import PublishPro from '../components/PublishPro'

export default {
  name: 'DepartmentPriceSetting',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      editColumns: [],//可编辑表头
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      submitLoading: false,
      specList: [
        {
          name: undefined,
          valueList: [
            {
              isTrue: false,
              name: ''
            }
          ]
        }
      ],
      dataProgramList: [],//保存数据中包含的规格
      programList: [],
      tabColumns: [],
      dataList: [],
      ruleForm: {
        proId: this.$route.query.proId, //产品ID
        priceDtoList: []
      },
      loading: false,//页面加载标志
      isMType: this.$route.query.isMType
    }
  },
  mounted() {
    this.isMType = this.$route.query.isMType
    this.editColumns = this.getEditColumns()
    this.tabColumns = this.editColumns
    this.getProCommodityNorm()
    this.getProCommodityOption()
  },
  methods: {
    // 获取焦点事件触发新增规格输入
    onSelectedChange(value, item, index) {
      const findItem = this.programList.find(proItem => value === proItem.name)
      item.key = findItem ? findItem.code : undefined
      this.onGenerateSpec()//自动生成
    },
    onFocusEvent(index, SonIndex) {
      if (this.specList[index].valueList.length < 5) {
        let flag = false
        this.specList[index].valueList.forEach(item => {
          if (item.name == '') {
            flag = true
          }
        })
        if (!flag) {
          this.specList[index].valueList.push({
            isTrue: false,
            name: ''
          })
        }
      }
    },
    onIsTrueChange(index, SonIndex) {
      if (this.specList[index].valueList.length > 0) {
        this.specList[index].valueList.splice(SonIndex, 1)
        const findIndex = this.specList[index].valueList.findIndex(valueItem => !valueItem.isTrue)
        if (findIndex < 0 && this.specList[index].valueList.length < 5) {
          //要追加输入框
          this.specList[index].valueList.push({
            isTrue: false,
            name: ''
          })
        }
        this.$nextTick(() => this.onGenerateSpec())//自动生成
      }
    },
    // 失去焦点后 选中checkbox
    onBlurvent(index, SonIndex) {
      let flag = false
      let textStr = this.specList[index].valueList[SonIndex].name
      if (!textStr) {
        return
      }
      this.specList[index].valueList.forEach((item, idx) => {
        this.getLogUtils().logWithTag(item.name)
        if (idx < SonIndex) {
          if (item.name == textStr) {
            flag = true
          }
        }
      })
      if (!flag) {
        this.specList[index].valueList[SonIndex].isTrue = true
        this.$nextTick(() => this.onGenerateSpec())//自动生成
      } else {
        this.$message.error('请勿重复输入')
      }
    },
    //删除规格
    deleteItem(item) {
      this.specList = this.specList.filter(sp => item.name !== sp.name)
      //生成建
      let specKey = 'dataIndex' + item.key
      //删除表数据
      this.dataList = this.dataList.map(editorItem => {
        let newItem = { ...editorItem }
        delete newItem[specKey]//删除当前属性
        return newItem
      })
      //删除表头
      this.tabColumns = this.tabColumns.filter(tabItem => tabItem.dataIndex !== specKey)
      this.$nextTick(() => this.onGenerateSpec()) //自动生成
    },
    //新增规格
    addSpec() {
      // 最多添加三个
      if (this.specList.length < 3) {
        this.specList.push({
          name: undefined,
          valueList: [
            {
              name: '',
              isTrue: false
            }
          ]
        })
      } else {
        this.$message.warn('最多只能添加三个规格')
      }
      this.getLogUtils().logWithTag('this.specList', this.specList)
    },
    //生成、追加规则
    onGenerateSpec() {
      //判断有没有添加（新的规则）
      let specList = this.specList.filter(item => {
        return item.name && item.valueList && item.valueList.length > 0 && item.valueList.some(valueItem => valueItem.isTrue)
      })

      let newList = specList.filter(item => {
        return !this.dataProgramList.some(promItem => promItem.key == item.key)
      })

      let newDataList = this.getTabDataList(specList)//生成全新的数据
      //新数据要更新表头
      this.tabColumns = this.getTabColumns(specList)
      if (newList && newList.length > 0) {
        this.dataProgramList = [...specList].map(item => {
          return {
            name: item.name,
            key: item.key
          }
        })
      } else {
        //将旧的数据放回来
        for (let i = 0, len = newDataList.length; i < len; i++) {
          let list = [...this.dataList]
          specList.forEach(spItem => {
            let keyValue = 'dataIndex' + spItem.key
            list = list.filter(dataItem => dataItem[keyValue] === newDataList[i][keyValue])
          })
          if (list && list.length > 0) {
            newDataList[i] = list[0]
          }
        }
      }
      this.dataList = [...newDataList]
    },
    getTabDataList(specList) {
      let newDataList = []//新增的部分
      if (specList && specList.length > 0) {
        specList.forEach((spItem, index, arr) => {
          let keyValue = 'dataIndex' + spItem.key
          let keyName = 'dataName' + spItem.key
          let emptyData = this.getEmptyData()
          let valueList = spItem.valueList.filter(item => item.isTrue)
          valueList = valueList.map(item => {
            let mapItem = { ...emptyData }
            mapItem.rowKey = this.getUUID()
            mapItem[keyValue] = item.name
            mapItem[keyName] = spItem.name
            return mapItem
          })
          //合并数据
          if (newDataList.length === 0) {
            newDataList = [...valueList]
          } else {
            let mergeList = []
            newDataList.forEach(item => {
              valueList.forEach(valueItem => {
                mergeList.push({
                  ...valueItem,
                  ...item,
                  rowKey: this.getUUID()//这里的需要重新生成
                })
              })
            })
            newDataList = [...mergeList]
          }
        })
      }
      return newDataList
    },
    getEmptyData() {
      if (String(this.isMType) === '1') {
        return {
          commodityOptionNo: '',
          priceDto: {
            sku: '',
            barCode: '',
            mfAuditPrice: '',
            advicePrice: '',
            commissionPrice: '',
            marketPrice: '',
            purchasePrice: '',
            stock: ''
          }
        }
      } else {
        return {
          commodityOptionNo: '',
          priceDto: {
            mfAuditPrice: '',
            advicePrice: '',
            commissionPrice: '',
            marketPrice: '',
            purchasePrice: '',
            stock: ''
          }
        }
      }
    },
    onSubmit() {
      this.validateSubmitParams()
        .then(res => {
          let length = this.dataList.length
          if (length > 0) {
            if (this.proSource > 0) {
              //更新佣金
              this.updateCommissionInfo()
            } else {
              this.requestSubmit()
            }
          } else {
            this.$message.error('请完善规格价格信息')
          }
        }).catch(reason => {
        this.$message.error('请完善规格价格信息')
      })
    },
    //更新佣金信息
    updateCommissionInfo() {
      this.submitLoading = true
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      let commissionList = dataList.map(item => {
        return {
          commission: Number.parseFloat(item.commissionPrice),
          optionId: item.optionId
        }
      })
      let params = {
        commissionList: commissionList,
        proId: this.proId
      }
      let url = '/product/commodity/editProCommodityCommission'
      this.getHttpServices().getProService().post(url, params)
        .then(res => {
          this.$message.success('佣金数据更新成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    requestSubmit() {
      this.submitLoading = true
      let dataList = [...this.dataList]
      let normParamList = []//规格信息列表
      this.specList.forEach(item => {
        normParamList.push({
          key: item.key,
          name: item.name
        })
      })
      let priceDto = {}
      if (String(this.isMType) === '1') {
        priceDto = {
          sku: '',
          barCode: '',
          mfAuditPrice: '',
          advicePrice: '',
          commissionPrice: '',
          marketPrice: '',
          purchasePrice: '',
          stock: ''
        }
      } else {
        priceDto = {
          mfAuditPrice: '',
          advicePrice: '',
          commissionPrice: '',
          marketPrice: '',
          purchasePrice: '',
          stock: ''
        }
      }
      let priceDtoList = dataList.map(item => {
        let newParamList = []
        normParamList.forEach(normItem => {
          let valueKey = 'dataIndex' + normItem.key
          newParamList.push({
            key: normItem.key,
            name: normItem.name,
            value: item[valueKey]
          })
        })
        return {
          optionId: item.optionId,
          commodityOptionNo: item.commodityOptionNo,
          priceDto: this.getValuesFromObject(priceDto, item),
          normParamList: newParamList
        }
      })
      let params = {
        proId: this.proId,
        priceDtoList: priceDtoList
      }
      this.getHttpServices().getProService().post('product/commodity/editProCommodityOption', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('套餐与价格新增成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //校提交信息
    validateSubmitParams() {
      return new Promise((resolve, reject) => {
        //校验表格输入信息
        let stopFlag = false
        for (let i = 0, length = this.dataList.length; i < length; i++) {
          if (stopFlag) {
            break
          }
          let tabItem = this.dataList[i]
          let editColumns = this.getEditColumns()
          for (let j = 0, eLength = editColumns.length; j < eLength; j++) {
            let tips = this.getErrorTips(tabItem, editColumns[j].scopedSlots.customRender)
            if (tips) {//有自定义
              stopFlag = true
              break
            }
          }
        }
        if (stopFlag) {
          reject()
        } else {
          resolve()
        }
      })
    },
    getProCommodityNorm() {
      this.getHttpServices().getBaseService().get('base/sysCode/getProCommodityNorm')
        .then(list => {
          this.getLogUtils().logWithTag('getProCommodityNorm', list)
          this.programList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取套餐的规格型号的接口
    getProCommodityOption() {
      this.loading = true
      this.getHttpServices().getProService().get('product/commodity/findProCommodityOption?proId=' + this.proId)
        .then(list => {
          this.getLogUtils().logWithTag('getProCommodityOption', list)
          if (list && list.length > 0) {
            this.dataProgramList = list[0].normParamList
            this.tabColumns = this.getTabColumns(list[0].normParamList)
            this.dataList = [...list].map(item => {
              let extraItem = {}
              item.normParamList.forEach(norm => {
                let keyValue = 'dataIndex' + norm.key
                let keyName = 'dataName' + norm.key
                extraItem[keyValue] = norm.value
                extraItem[keyName] = norm.name
                extraItem.rowKey = this.getUUID()
              })
              return {
                ...item.priceDto,
                ...extraItem,
                optionId: item.optionId,
                commodityOptionNo: item.commodityOptionNo
              }
            })


            let specList = []//所有的规格列表
            //填充 valueList    ｛isTrue:false name:""｝
            list.forEach(item => {
              item.normParamList.forEach(normItem => {
                let findIndex = specList.findIndex(spItem => spItem.name === normItem.name)
                let addItem = {
                  isTrue: true,
                  name: normItem.value,
                  key: normItem.key
                }
                if (findIndex >= 0) {
                  if (specList[findIndex].valueList) {
                    const index = specList[findIndex].valueList.findIndex(valueItem => valueItem.name === normItem.value)
                    if (index < 0) {
                      specList[findIndex].valueList.push(addItem)
                    }
                  } else {
                    specList[findIndex].valueList = [addItem]
                  }
                } else {
                  specList.push({
                    name: normItem.name,
                    key: normItem.key,
                    valueList: [addItem]
                  })
                }
              })
            })
            specList.forEach(item => {
              if (item.valueList && item.valueList.length < 5) {
                item.valueList.push({
                  name: '',
                  isTrue: false
                })
              }
            })
            this.specList = [...specList]
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.loading = false)
    },
    getTabColumns(normParamList) {
      //不可编辑表头
      let columns = []
      if (normParamList && normParamList.length > 0) {
        normParamList.forEach(item => {
          columns.push({
            title: item.name,
            dataIndex: 'dataIndex' + item.key
          })
        })
      }
      //可编辑表头
      let editColumns = this.getEditColumns()
      return [...columns, ...editColumns]
    },
    //获取可选的规格列表
    getCanSelectedOptions(item, index) {
      const selectedList = this.specList.filter((sItem, sIndex, arr) => sIndex !== index)//已经选择的项（忽略当前项）
      return this.programList.filter(pItem => {
        return selectedList.every(sItem => sItem.key !== pItem.code)
      })
    },
    //获取可编辑表头数据
    getEditColumns() {
      let mTypeArr = [
        {
          title: 'SKU',
          dataIndex: 'sku',
          width: '140px',
          scopedSlots: { customRender: 'sku' }
        },
        {
          title: '商品条码',
          dataIndex: 'barCode',
          width: '140px',
          scopedSlots: { customRender: 'barCode' }
        }
      ]
      let defaultArr = [
        {
          title: '同行价(元)',
          dataIndex: 'mfAuditPrice',
          width: '130px',
          scopedSlots: { customRender: 'mfAuditPrice' }
        },
        {
          title: '销售价(元)',
          dataIndex: 'advicePrice',
          width: '130px',
          scopedSlots: { customRender: 'advicePrice' }
        },
        {
          title: '佣金(元)',
          dataIndex: 'commissionPrice',
          width: '130px',
          scopedSlots: { customRender: 'commissionPrice' }
        },
        {
          title: '市场价(元)',
          dataIndex: 'marketPrice',
          width: '130px',
          scopedSlots: { customRender: 'marketPrice' }
        },
        {
          title: '采购价(元)',
          dataIndex: 'purchasePrice',
          width: '130px',
          scopedSlots: { customRender: 'purchasePrice' }
        },
        {
          title: '库存',
          dataIndex: 'stock',
          width: '130px',
          scopedSlots: { customRender: 'stock' }
        },
        {
          title: '上架编码',
          dataIndex: 'commodityOptionNo',
          width: '130px',
          scopedSlots: {
            customRender: 'commodityOptionNo'
          }
        }
      ]
      if (String(this.isMType) === '1') {
        return mTypeArr.concat(defaultArr)
      } else {
        return defaultArr
      }
    },

    //获取输入框的校验规则
    getValidateStatus(record, customRender) {
      let errorTips = this.getErrorTips(record, customRender)
      return errorTips ? 'error' : 'success'
    },
    getErrorTips(record, customRender) {
      if (customRender === 'commodityOptionNo') {
        return ''
      }
      if (record[customRender] === undefined || record[customRender] === '') {
        return '请输入'
      }
      /* if(customRender === 'sku'){
         if (record[customRender] === undefined || record[customRender] === '') {
           return '请输入sku'
         }
       }
       if(customRender === 'barCode'){
         if (record[customRender] === undefined || record[customRender] === '') {
           return '请输入商品条码'
         }
       }*/
      //采购价、佣金可以为0
      if (customRender === 'purchasePrice' || customRender === 'commissionPrice') {
        if (/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(record[customRender])) {
          return ''
        } else {
          return '金额有误'
        }
      }
      if (customRender === 'stock') {
        if (/^[0-9]\d{0,5}$/.test(record[customRender])) {
          return ''
        } else {
          return '库存有误'
        }
      } else if (customRender === 'sku' || customRender === 'barCode') {
        if (record[customRender] === undefined || record[customRender] === '' || record[customRender] === null) {
          return '请输入'
        } else if (record[customRender].length > 30) {
          return '不能超过30位'
        } else {
          return ''
        }
      } else {
        //价格校验规则
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/.test(record[customRender])) {
          if (record.commissionPrice && record.advicePrice && record.mfAuditPrice && (customRender === 'commissionPrice' || customRender === 'advicePrice' || customRender === 'mfAuditPrice')) {
            let commissionPrice = (record.advicePrice - record.mfAuditPrice).toFixed(2)
            if (Number.parseFloat(commissionPrice) < record.commissionPrice) {
              return '销售价-同行价必须大于或等于佣金'
            }
          }
          return ''
        } else {
          return '金额有误'
        }
      }
    },
    getValuesFromObject(keysObject, targetObject) {
      if (keysObject && targetObject && typeof keysObject === 'object' && typeof targetObject === 'object') {
        let keys = Object.keys(keysObject)
        if (keys && keys.length > 0) {
          let newObject = {}
          keys.forEach(key => {
            newObject[key] = targetObject[key]
          })
          return newObject
        }
      }
      return undefined
    },
    getUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now() //use high-precision timer if available
      }
      const uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return uid
    }
  }
}
</script>
<style lang="less">
.department-price-setting {
  .ant-spin-nested-loading > div > .ant-spin {
    height: 100%;
  }

  .spin-content {
    /*border: 1px solid #91d5ff;*/
    /*background-color: #e6f7ff;*/
    margin-top: 100px;
    padding: 30px;
    text-align: center;
  }

  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 800px;
      flex-grow: 1;
      position: relative;

      .content-flex {
        display: flex;
        flex-wrap: wrap;

        .content-box {
          display: flex;
          align-items: center;

          .content-row {
            display: flex;
            align-items: center;
            margin-right: 10px;

            .check-input {
              margin-left: 5px;
              max-width: 200px;
            }
          }

        }
      }
    }

    .table-model {
      thead {
        border-bottom: 1px solid #e9e9e9;
        background-color: #fafafa;

        tr {
          th {
            padding: 4px;
            min-width: 70px;
          }
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e9e9e9;

          td {
            min-width: 70px;
          }
        }
      }

      .ant-form-item {
        margin-top: 20px;
      }
    }
  }

  .pt10 {
    padding-top: 10px;
  }

  .ml15 {
    margin-left: 15px;
  }

  .card-title {
    padding-left: 10px;
    border-left: 1px solid #FAAD14;
    line-height: 32px;
    margin-right: 5px;
  }
}

</style>
